import Braze from '@braze/web-sdk';
import { createContext } from 'react';

export const BrazeContext = createContext<typeof Braze | null>(null);

/** We re-export the Braze namespace as a type only. This makes it easier to import correctly:
 * - It now has a name
 * - The actual package will panic on import if it is imported on the server, since it assumes
 *   it is always in a browser. This alias is type-only, and does not run the module code.
 */
export type { default as Braze } from '@braze/web-sdk';
